// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"451eb0a07a22a13ea10d","655":"a138b4a2777db150e3e6"}[chunkId] + ".js";
};